import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import { BASE_IMAGE_PATH } from '../../../configs/api';
import * as ExposureService from '../../../services/exposureService'
import Currency from '../currency'
import * as _ from 'lodash';

class UserEventExposure extends Component {
   constructor(props) {
      super(props);
      this.state = {
         loader: true,
         showData: false,
         userExposures: [],
         userExpoEventsDic: {}
      };
   }

   async componentDidMount() {
      let userExpo = await ExposureService.getEventExposureByUserId(this.props.user.username)
      const userExpoEventsDic = Object.assign({}, ...userExpo.events.map((x) => ({[x.eventId]: {openDate:x.openDate}})))
      userExpo = userExpo.items
      let grp = _.groupBy(userExpo, 'marketBettingType')
      if (!!grp["LINE"]) {
         const result = [...grp["LINE"].reduce((r, o) => {

            const key = o.eventId

            const item = r.get(key) || Object.assign({}, o, {
               exposure: 0
            });

            item.exposure += +o.exposure;
            item.marketType = "FANCY"
            return r.set(key, item);
         }, new Map()).values()];
         
         if (Object.keys(grp).length > 1) {
            userExpo = []
            delete grp['LINE']
            Array.prototype.forEach.call(Object.keys(grp),function(key) {
               userExpo = userExpo.concat(grp[key])
            });
            userExpo = userExpo.concat(result);
         } else {
            userExpo = result
         }
      }
      this.setState({ userExposures: userExpo, userExpoEventsDic: userExpoEventsDic , showData: true, loader: false })
   }

   render() {
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="eventunsettle" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-lg modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">User Event Exposure</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body lst-pop pt-0">
                        {!this.state.showData && !!this.state.loader ? <div className={"text-center my-4"}><img alt="" style={{ width: "45px" }} src={BASE_IMAGE_PATH + "/aimg/loader.gif"}></img></div> : null}
                        {!!this.state.showData &&
                           <div className="mt-3">
                              <table className="table table-sm table-bordered font-14 w-100 nowrap ">
                                 <thead>
                                    <tr className="bg-dark importeve">
                                       <td className="event-width40"><span className="font-weight-bold text-white">Event Date &amp; Time</span></td>
                                       <td className="event-width10"><span className="font-weight-bold text-white">Series Name</span></td>
                                       <td className="event-width12"><span className="font-weight-bold text-white">Event Name</span></td>
                                       <td className="event-width12"><span className="font-weight-bold text-white">Market Type</span></td>
                                       <td className="event-width12 text-right"><span className="font-weight-bold text-white">Exposure</span></td>
                                    </tr>
                                 </thead>
                                 <tbody className="bg-white">
                                    {!!this.state.userExposures && this.state.userExposures.map((expo) => {
                                       const evtDt = !!this.state.userExpoEventsDic[expo.eventId] ? this.state.userExpoEventsDic[expo.eventId].openDate : ""
                                       return (<>
                                          <tr>
                                             <td>{evtDt !== '' ? new Date(evtDt).toLocaleString("hi-IN") : "-"}</td>
                                             <td>{!!expo.competitionName ? expo.competitionName : "-"}</td>
                                             <td>{!!expo.eventName ? expo.provider === "DRC" || expo.provider === "DIGITAIN" || (expo.eventTypeId === '99' && expo.provider !== "LOTUS") || expo.eventTypeId === '999'? expo.eventName :
                                                expo.competitionName === "IP" ? <a href={"/casinoanalysisuser/" + expo.competitionId.split("/")[1]} className=" topboxlink">{expo.eventName}</a> :
                                                   expo.eventTypeId === "300" ? <a href={"/binaryanalysis/" + expo.eventId} className=" topboxlink">{expo.eventName}</a> : 
                                                   <a href={"/sportanalysis/" + expo.eventId} className=" topboxlink">{expo.eventName}</a>  : "-"}
                                             </td>
                                             <td>{!!expo.marketType ? expo.marketType.replaceAll("_", " ") : "-"}</td>
                                             <td className="text-right">{!!expo.exposure ? expo.provider === "DRC" || expo.provider === "DIGITAIN" || (expo.eventTypeId === '99' && expo.provider !== "LOTUS") || expo.eventTypeId === '999'? <Currency className="font-weight-bold" amount={expo.exposure} showColor={true} /> :
                                                expo.competitionName === "IP" ? <a href={"/casinoanalysisuser/" + expo.competitionId.split("/")[1]} className=" topboxlink"><Currency className="font-weight-bold" amount={expo.exposure} showColor={true} /></a> :
                                                expo.eventTypeId === "300" ? <a href={"/binaryanalysis/" + expo.eventId} className=" topboxlink"><Currency className="font-weight-bold" amount={expo.exposure} showColor={true} /></a> :
                                                   <a href={"/sportanalysis/" + expo.eventId} className=" topboxlink"><Currency className="font-weight-bold" amount={expo.exposure} showColor={true} /></a> : "-"}
                                             </td>
                                          </tr>
                                       </>)
                                    })}
                                 </tbody>
                              </table>
                           </div>}
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
            </div>
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(UserEventExposure);